export enum makerCheckerStatusEnum {
  pending = 1,
  accepted = 2,
  rejected = 3,
}
